<div class="loading-container">
  <global-spinner></global-spinner>
</div>
<div class="nav-actions">
  <div class="nav-left">
    <img (click)="openNav()" src="assets/images/menu.svg" alt="Open menu">
    <img (click)="home()" src="assets/images/CRC_logo.svg" alt="ResourceCenter logo" />
  </div>

  <div class="nav-right">
    <button class="pill-btn" (click)="contactUs()">{{ (isCustomer ? "contact.title.manager" : "contact.title.team") | translate }}</button>
    @if(hasAccess(RoleConstants.VIEW_HELP_PAGE)) {
      <button class="pill-btn" (click)="getStarted()">{{ "homepage.getStarted" | translate }}</button>
    }
    <div class="dropdown">
      <button class="icon-btn" aria-label="Language" data-bs-toggle="dropdown" aria-expanded="false"
        aria-controls="dropdown-basic">
        <img src="assets/images/globe.svg" alt="Language" />
      </button>
      <ul class="dropdown-menu locale-menu">
        @for (locale of localeService.LOCALES; track locale) {
        <li>
          <a class="dropdown-item locale-dropdown-item" (click)="selectLocale(locale.localeId)">
            <div class="language p-2">{{locale.localeName}}</div>
          </a>
        </li>
        }
      </ul>
    </div>
    @if(sessionDetails.invokedByCrc) {
      <button class="blue-pill-btn" (click)="exitCustomerView()">
        <img class="btn-close-icon" src="assets/images/x.svg"/>
        <div class="btn-text">{{ "homepage.exitCustomerView" | translate }}</div>
      </button>
    }
  </div>
</div>
